<template>
    <div v-if="data.show" :class="{ notification: true }" ref="notificationEl">
        {{ data.message }}
    </div>
</template>

<script setup>
import { inject, onMounted, nextTick, ref, onUpdated } from 'vue';

// получаем доступ к данным и методам из провайдеров
const data = inject('notificationData');

// Референс на DOM-элемент
const notificationEl = ref(null);

// Обновляем позицию уведомления при появлении
onUpdated(() => {
    if (data.value.show) {
        nextTick(() => {
            positionNotification();
        });
    }
});

// Устанавливаем положение уведомления посередине экрана
function positionNotification() {
    if (notificationEl.value) {
        const container = document.getElementById('app');
        if (container) {
            const notificationRect = notificationEl.value.getBoundingClientRect();
            const offsetLeft = Math.max(container.clientWidth / 2 - notificationRect.width / 2, 0);
            notificationEl.value.style.left = `${offsetLeft}px`;
        }
    }
}

// Позиционирование при монтировании компонента
onMounted(() => {
    positionNotification();
});
</script>

<style scoped lang="scss">
@use '~@/assets/styles/vars' as *;

@keyframes fadeIn {
    from { transform: translateY(-50%); opacity: 0; }
    to   { transform: translateY(0);     opacity: 1; }
}

.notification {
    position: fixed;
    transition: $transition;
    z-index: 20;
    padding: 10px 15px;
    border-radius: 30px;
    top: 25px;
    background: rgba(220, 51, 223, 0.5);
    font-size: 0.8rem;
    font-weight: 400;
    color: $white;
    backdrop-filter: blur(10px);
    box-shadow: $shadow;

    animation-name: fadeIn;
    animation-duration: 0.5s;
    animation-timing-function: ease-in-out;
    animation-fill-mode: forwards;

    cursor: pointer;
}

.notification:hover {
    background: rgba(220, 51, 223, 0.6);
}

@media screen and (max-width: 750px) {
    .notification {
        max-width: 80%;
        text-align: center;
        padding: 8px 13px;
        font-size: 0.7rem;
    }
}
</style>
